import { lazy } from 'react';

const CertifiedAvailableProducerPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/certificates/producer/avaibles',
			component: lazy(() => import('./CertifiedAvailablePage'))
		}
	]
};

export default CertifiedAvailableProducerPageConfig;